import * as React from 'react'

// React remounts a portal when its container node changes. A stable node can move instead.
export function useReparentedNode(host: HTMLElement | null) {
  const [node] = React.useState(() => {
    const element = document.createElement('div')
    element.style.cssText =
      'display:flex;flex:1 1 auto;flex-direction:column;width:100%;height:100%;min-width:0;min-height:0'
    return element
  })

  React.useLayoutEffect(() => {
    if (host) {
      host.appendChild(node)
    }
  }, [host, node])

  React.useLayoutEffect(() => {
    return () => {
      node.remove()
    }
  }, [node])

  return node
}
